import axios from './templateInstance'

/**
 * Partial update through the {operation, values} envelope the product APIs use.
 * An omitted section_ids leaves the existing links alone; an empty array clears
 * them.
 */
const patchDesignTemplate = async (id: string, values: Record<string, any>) => {
  try {
    const response: any = await axios.patch(`/design-templates/${id}`, {
      operation: 'update',
      values,
    })
    return response?.data ?? response
  } catch (error) {
    console.error('Error patching design template:', error)
    return null
  }
}

export default patchDesignTemplate
